import {handleFetchError, HtmlDialog, showNotice} from "../../helpers/functions.js";
import JSX from "../../helpers/react.js";
import RefObject = JSX.RefObject;
import {ServerApi} from "../../api.js";


export function AddNewAppDialog({title, desc, appID}: { title?: string, desc?: string, appID: number }) {
    title ??= '';
    desc ??= '';
    const el: RefObject<HTMLDivElement> = {};
    const ref: {
        title: RefObject<HTMLInputElement>,
        desc: RefObject<HTMLTextAreaElement>,
        addBtn: RefObject<HTMLInputElement>
    } = {
        desc: {},
        title: {},
        addBtn: {}
    }
    const $element = (
        <HtmlDialog className="add-new-app" OnClose={() => $(el.value!).remove()} ref={el}>
            <div className="top-data">
                <h1>{appID ? <>Отредактировать приложение «{title}»</> : <>Добавить новое DEV приложение</>}</h1>
                <div className="content" style="display:block;">
                    <p>Приложение нужно, чтобы вызывать методы API и получать по ним статистику</p>
                    <input name="title" type="text" placeholder="Название приложения" ref={ref.title} value={title} className="bordered" style={{marginBottom: "10px"}}/>
                    <textarea className="message-text bordered" placeholder="Описание" ref={ref.desc} style={{resize: "vertical"}}>{desc}</textarea>
                </div>
            </div>
            <div className="bottom-buttons">
                <div className="cancel-button main-button neutral bordered">Отмена</div>
                <div className="save-button main-button bordered"
                     onClick={onSaveBtnClick} ref={ref.addBtn}>{!appID ? "Добавить" : "Изменить"}</div>
            </div>

        </HtmlDialog>
    );
    return $element;

    async function onSaveBtnClick() {
        if (!ref.title.value!.value || !ref.desc.value!.value) {
            showNotice('Заполните все поля', 'Ошибка ввода', 'error');
            return;
        }
        if (ref.addBtn.value!.classList.contains('blocked')) return;
        ref.addBtn.value!.classList.add('blocked');
        try {
            if (appID) {
                await ServerApi.apps.update(appID, {
                    description: ref.desc.value!.value,
                    name: ref.title.value!.value
                });
                showNotice('Приложение успешно изменено', 'Успех', 'success');
                location.reload();
            } else {
                const id = await ServerApi.apps.create(ref.title.value!.value, ref.desc.value!.value);
                showNotice('Приложение успешно создано', 'Успех', 'success');
                location.href = `/dev/applications/${id}`;
            }
        } catch (e) {
            handleFetchError(e);
        } finally {
            ref.addBtn.value!.classList.remove('blocked');
        }
    }
}